import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fs-18"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = {
  key: 0,
  class: "fs-14"
}
const _hoisted_5 = {
  key: 1,
  class: "pr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isWaitTimeAction)
    ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.waitTime), 1))
    : (_openBlock(), _createBlock("span", _hoisted_2, [
        _createVNode("span", {
          class: ["fs-18", { 'pr-2': _ctx.isTimeCondition }]
        }, _toDisplayString(_ctx.isTimeCondition ? _ctx.timeCondition : _ctx.timeTrigger), 3),
        (!_ctx.isForEveryday)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.weekDays, (day, index) => {
                return (_openBlock(), _createBlock("span", {
                  key: day.day + day.dayName
                }, [
                  _createVNode("span", {
                    class: ["fs-14 week-day", { disabled: day.disabled }]
                  }, _toDisplayString(day.dayName), 3),
                  (index < _ctx.weekDays.length - 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_4, " - "))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_5, " | " + _toDisplayString(_ctx.$t("AppResource.EveryDay")), 1))
      ]))
}